import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import OutsideHandler from 'components/common/OutsideHandler';

import en from './lang-flags/en.svg';
import ar from './lang-flags/ar.svg';
import id from './lang-flags/id.svg';
import ru from './lang-flags/ru.svg';
import pt from './lang-flags/pt.svg';
import tr from './lang-flags/tr.svg';
import uk from './lang-flags/uk.svg';

import './LanguageSwitcher.css';

const langOptions = [
  {
    key: 'en',
    text: 'English',
    image: en,
  },
  {
    key: 'ar',
    text: 'عرب',
    image: ar,
  },
  {
    key: 'id',
    text: 'bahasa Indonesia',
    image: id,
  },
  {
    key: 'pt',
    text: 'Português',
    image: pt,
  },
  {
    key: 'ru',
    text: 'Russian',
    image: ru,
  },
  {
    key: 'tr',
    text: 'Türkçe',
    image: tr,
  },
  {
    key: 'uk',
    text: 'Українська',
    image: uk,
  },
];

const LanguageSwitcher = props => {
  const [langList, setLangList] = useState(false);
  const { i18n } = useTranslation();
  const { onChange } = props;

  const toggleListLanguage = () => {
    setLangList(!langList);
  };

  const options = langOptions.map((item) => {
    return (
      <div 
        className="option" 
        key={item.key}
        onClick={() => {
          i18n.changeLanguage(item.key);
          toggleListLanguage();
          onChange(item.key);
        }}>
        <img src={item.image} />
        <div className="option-text">{item.text}</div>
      </div>
    );
  });

  const currentLang = langOptions.find(item => item.key === i18n.language);
  const langPic = currentLang ? currentLang.image : en;

  return (
    
    <div className="language-switcher__component max">
      <img
        className="current-pic"
        src={langPic}
        onClick={toggleListLanguage}
      />
      <OutsideHandler handleClickOutside={() => setLangList(false)}>
        {langList && <div className="option-wrapper">{options}</div>}
      </OutsideHandler>

    </div>
  );
};

export default LanguageSwitcher;
